import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import PrecisionGameUIVertical from "@/features/precisionGame/components/precision.game.ui.vertical";

const PrecisionGameVertical: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Test Your Precision");

  return (
    <>
      <PrecisionGameUIVertical />
    </>
  );
};

export default PrecisionGameVertical;
